
/**
 * エラーページ
 * アプリケーションエラーが発生した際の表示コンポーネント
 */

import { useEffect } from 'react'
import { Button } from '@/shared/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/ui/card'
import { AlertTriangle, RefreshCw, Home } from 'lucide-react'
import { Link } from 'react-router-dom'

/**
 * エラーページコンポーネント
 */
export default function Error({
    error,
    reset,
}: {
    /** エラーオブジェクト */
    error: Error & { digest?: string }
    /** リセット関数 */
    reset: () => void
}) {
    useEffect(() => {
        console.error('Application error:', error)
    }, [error])

    return (
        <div className="min-h-screen flex items-center justify-center bg-background px-4">
            <Card className="w-full max-w-md">
                <CardHeader className="text-center">
                    <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
                        <AlertTriangle className="h-8 w-8 text-destructive" />
                    </div>
                    <CardTitle className="text-2xl font-semibold text-foreground">
                        エラーが発生しました
                    </CardTitle>
                </CardHeader>
                <CardContent className="text-center space-y-4">
                    <p className="text-muted-foreground">
                        申し訳ございません。予期しないエラーが発生しました。
                    </p>
                    {error.digest && (
                        <p className="text-xs text-muted-foreground font-mono bg-muted p-2 rounded">
                            エラーID: {error.digest}
                        </p>
                    )}
                    <div className="flex flex-col sm:flex-row gap-3 justify-center">
                        <Button onClick={reset} variant="default">
                            <RefreshCw className="mr-2 h-4 w-4" />
                            再試行
                        </Button>
                        <Button asChild variant="outline">
                            <Link to="/">
                                <Home className="mr-2 h-4 w-4" />
                                ホームに戻る
                            </Link>
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    )
} 